module.exports = __webpack_public_path__ + "static/img/jianzhugongcheng.fd80fb57.png";